import { Component, Inject, Input, OnInit } from '@angular/core';
import { FeedbackStatusEnum } from "../../enums/feedback-status.enum";
import { FeedbackService } from '../../services/feedback/feedback.service';
import { FeedbackModel } from '../../models/feedback.model';
import { DropdownOption } from '@cms/shared-library';

@Component({
    selector: 'app-feedback-panel',
    templateUrl: './feedback-panel.component.html',
    styleUrls: ['./feedback-panel.component.scss'],
    standalone: false
})
export class FeedbackPanelComponent implements OnInit {
  feedbackModel: FeedbackModel = new FeedbackModel();
  feedbackStatusEnum = FeedbackStatusEnum;

  showSuccess = false

  showEmailError = false
  currentLang: any;
  feedbackOptionValues: DropdownOption[];

  @Input() pageName: string = '';

  constructor(@Inject('FeedbackService') public feedbackService: FeedbackService) { }

  ngOnInit(): void {
    this.setupOptionsForFeedbackAbout();

  }

  setupOptionsForFeedbackAbout() {
    this.feedbackService.GetFeedbackTypes().subscribe(res => { 
      this.feedbackModel.feedbackAboutOptions = res; 
      this.feedbackModel.feedbackAboutOptions.forEach(option => {
        this.feedbackOptionValues.push(new DropdownOption(option.feedbackTypeValue, option.feedbackTypeValue, option.feedbackTypeKey))
      })
    });
  }

  setupFeedbackType(type: any) {
    if (type == this.feedbackModel.feedbackStatusId) this.feedbackModel = new FeedbackModel();
    else if (this.feedbackModel.feedbackStatusId == null) this.feedbackModel = new FeedbackModel(this.uuidv4(), '', type, '', false, false, this.pageName != '', this.pageName, false, '', [])
    else this.feedbackModel.feedbackStatusId = type
    this.setupOptionsForFeedbackAbout();
  }

  resetFeedback() {
    this.feedbackModel = new FeedbackModel();
    //this.showEmailError = false;
  }

  replyExpectedKeyUp($event: KeyboardEvent) {
    if ($event.key.toLowerCase() === 'enter') {
      this.feedbackModel.isReplyExpected = !this.feedbackModel.isReplyExpected;
    }
  }

  researchKeyUp($event: KeyboardEvent) {
    if ($event.key.toLowerCase() === 'enter') {
      this.feedbackModel.isParticipatingInResearch = !this.feedbackModel.isParticipatingInResearch;
    }
  }

  submitFeedback() {
    this.feedbackService.SaveFeedback(this.feedbackModel).subscribe(() => {
      this.feedbackModel = new FeedbackModel();
      this.showSuccess = true;
    })
  }

  /* global script */
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}